<template>
  <v-row>
    <v-col cols="12">
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span class="primary--text" v-bind="attrs" v-on="on" @click="copyToClipboard">
            <v-icon small class="mr-2">mdi-link-variant</v-icon>linkwith.pappyon.com/{{ transientLinkInBio.id }}
          </span>
        </template>
        <span>Press to copy link</span>
      </v-tooltip> -->

      <template>
        <v-menu :close-on-content-click="false" max-width="250" :offset-y="true">
          <template v-slot:activator="{ on, attrs }">
            <div class="text-body-1 mt-4 share-mc d-inline-block primary--text" v-bind="attrs" v-on="on">
              <v-icon color="primary">mdi-link-variant</v-icon> Share link &nbsp;
            </div>
          </template>
          <v-card>
            <v-tabs v-model="shareMenuTab">
              <v-tab class="text-capitalize">Link</v-tab>
              <v-tab class="text-capitalize" eager>QR code</v-tab>
            </v-tabs>
            <v-divider></v-divider>
            <v-tabs-items v-model="shareMenuTab">
              <v-tab-item eager>
                <v-list class="px-2">
                  <v-list-item class="py-0" @click="shareViaEmail">
                    <!-- <a href="mailto:?subject=Share Multi Connect Link" class="text-decoration-none"> -->
                    <v-list-item-icon class="mr-2">
                      <v-icon small>mdi-email-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle>Share via email</v-list-item-subtitle>
                    </v-list-item-content>
                    <!-- </a> -->
                  </v-list-item>
                  <v-list-item class="py-0" @click="copyToClipboard">
                    <v-list-item-icon class="mr-2">
                      <v-icon small>mdi-content-copy</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle>Copy link</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-tab-item>
              <v-tab-item eager>
                <div class="d-flex justify-center align-center flex-column py-4">
                  <div
                    class="text-body-2 
                             text-left px-4  grey--text"
                  >
                    Here is your unique QR code that will direct people to your link when scanned.
                  </div>

                  <QRCode :link="linkWithPappyon" :logo="qrCodeLogo" />
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-menu>
      </template>
    </v-col>
    <!-- <p>transientLinkInBio.links.length: {{ transientLinkInBio.links.length }}</p> -->
    <v-col cols="12" v-if="transientLinkInBio.links.length == 0">
      <AddLinkMenuButton @addHeading="addLink('heading', 0)" @addLink="addLink('link', 0)" :showHelpText="true" />
    </v-col>

    <v-col cols="12">
      <v-form ref="addEditLinkForm">
        <draggable
          v-model="transientLinkInBio.links"
          :animation="200"
          group="links"
          filter=".action-button"
          :class="drag ? 'cursor-grabbing' : ''"
          @start="drag = true"
          @end="drag = false"
        >
          <template v-for="(link, index) in transientLinkInBio.links">
            <v-hover v-slot="{ hover }" :key="`hover${index}`">
              <div>
                <v-card
                  elevation="3"
                  :key="link.id"
                  :ref="`card${index}`"
                  :class="[
                    { 'mt-5': index == 0 },
                    { 'cursor-grab': hover },
                    { 'mt-9': link.type == 'heading' && index != 0 },
                    'draggable-card mb-3',
                  ]"
                >
                  <!--Start: Heading-->
                  <v-card-text v-if="link.type == 'heading'">
                    <div class="d-flex justify-content-start align-center">
                      <v-icon>mdi-drag-vertical</v-icon>
                      <v-text-field
                        outlined
                        dense
                        label="Heading"
                        v-model="link.heading"
                        class="mr-4 ml-2 mt-4"
                        :rules="requiredRules"
                        :ref="'link' + index"
                        validate-on-blur
                        @focus="$root.$emit('linkFocused', index)"
                      ></v-text-field>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="mr-2 ml-1 mb-auto mt-4"
                            @click="link.isHidden = !link.isHidden"
                            v-text="!link.isHidden ? 'mdi-eye-outline' : 'mdi-eye-off'"
                          ></v-icon>
                        </template>
                        <span>{{ !link.isHidden ? "Hide" : "Show" }}</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" class="mr-1 mb-auto mt-4" @click="handleRemove(index)"
                            >mdi-trash-can-outline</v-icon
                          >
                        </template>
                        <span>Delete</span>
                      </v-tooltip>
                    </div>
                  </v-card-text>
                  <!--End: Heading--->

                  <!--Start: Other Links-->
                  <v-card-text v-else>
                    <div class="d-flex justify-start align-center pt-6 pb-1">
                      <v-icon>mdi-drag-vertical</v-icon>

                      <div class="d-flex justify-start align-start flex-grow-1">
                        <v-row no-gutters class="ml-2 mr-4">
                          <v-col cols="12">
                            <v-text-field
                              outlined
                              dense
                              label="Title"
                              counter
                              maxlength="30"
                              v-model="link.title"
                              :rules="linkTitleRules"
                              :ref="'link' + index"
                              validate-on-blur
                              @focus="$root.$emit('linkFocused', index)"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              outlined
                              dense
                              label="URL"
                              v-model="link.url"
                              :ref="'url' + index"
                              :rules="requiredRules"
                              validate-on-blur
                              @input="handleChange(link)"
                              @focus="$root.$emit('linkFocused', index)"
                            >
                              <template slot="append">
                                <v-progress-circular
                                  v-if="link.isLoading"
                                  indeterminate
                                  color="accent"
                                  :size="24"
                                  :width="3"
                                ></v-progress-circular>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <!-- <v-switch
                              label="Thumbnail"
                              v-model="link.hasThumbnail"
                              class="mt-0"
                              @change="handleChange(link)"
                            ></v-switch> -->
                            <template v-if="link.hasThumbnail">
                              <template>
                                <v-btn
                                  outlined
                                  color="primary"
                                  class="mt-3 mb-5"
                                  v-if="link.thumbnailUrl == ''"
                                  @click="uploadThumbnail(link)"
                                  >Add thumbnail</v-btn
                                >
                                <template v-if="link.thumbnailUrl != ''">
                                  <div class="d-flex mt-2 mb-5">
                                    <v-card class="mr-2 pa-0 outlined-border">
                                      <v-img
                                        :aspect-ratio="378 / 250"
                                        height="125"
                                        width="189"
                                        :src="link.thumbnailUrl"
                                      ></v-img>
                                    </v-card>
                                    <div>
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-avatar
                                            color="white"
                                            class="elevation-5 d-block mb-2"
                                            size="25"
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="uploadThumbnail(link)"
                                          >
                                            <v-icon small>mdi-image</v-icon>
                                          </v-avatar>
                                        </template>
                                        <span>
                                          Change image
                                        </span>
                                      </v-tooltip>
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-avatar
                                            color="white"
                                            class="elevation-5 d-block mb-2"
                                            size="25"
                                            @click="deleteUploadedThumbnail(link)"
                                            v-bind="attrs"
                                            v-on="on"
                                          >
                                            <v-icon small>mdi-trash-can</v-icon>
                                          </v-avatar>
                                        </template>
                                        <span>
                                          Delete image
                                        </span>
                                      </v-tooltip>
                                    </div>
                                  </div>
                                </template>
                              </template>
                            </template>
                          </v-col>
                        </v-row>
                      </div>
                      <!-- <div class=" mb-auto"> -->
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="mr-2 mb-auto"
                            @click="link.isHidden = !link.isHidden"
                            v-text="!link.isHidden ? 'mdi-eye-outline' : 'mdi-eye-off'"
                          ></v-icon>
                        </template>
                        <span>{{ !link.isHidden ? "Hide" : "Show" }}</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="mr-2 mb-auto" v-bind="attrs" v-on="on" @click="handleRemove(index)"
                            >mdi-trash-can-outline</v-icon
                          >
                        </template>
                        <span>Delete</span>
                      </v-tooltip>
                      <!-- </div> -->
                    </div>
                  </v-card-text>
                  <!--End: Other Links-->
                </v-card>

                <v-menu max-width="180" offset-y transition="scale-transition">
                  <template v-slot:activator="{ on, attrs, value }">
                    <v-sheet height="8" color="transparent">
                      <v-scale-transition origin="center">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          rounded
                          v-show="hover || value"
                          fab
                          :color="hover || value ? 'primary' : 'primary'"
                          x-small
                          depressed
                          :class="[{ 'show-btns': hover || value }, 'mt-n12 ml-4 mb-0']"
                          ><v-icon :color="hover || value ? 'white' : transparent">mdi-plus</v-icon></v-btn
                        >
                      </v-scale-transition>
                    </v-sheet>
                  </template>
                  <v-list nav>
                    <v-list-item @click="addLink('heading', index + 1)">
                      <v-list-item-title>Add new heading</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="addLink('link', index + 1)">
                      <v-list-item-title>Add new link</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <!-- <AddLinkMenuButton
                  :key="`insertLink${link.id}`"
                  :btnColor="hover ? 'primary' : transparent"
                  :btnClass="[{ 'show-btns': hover }, { 'hide-btns': !hover }, 'mt-n12 ml-4 mb-0']"
                  :iconColor="hover ? 'white' : transparent"
                  @addHeading="addLink('heading', index + 1)"
                  @addLink="addLink('link', index + 1)"
                /> -->
                <!-- :btnColor="hover ? 'primary' : transparent" -->
                <!-- :btnClass="[{ 'show-btns': hover }, { 'hide-btns': !hover }, 'mt-n12 ml-4 mb-0']" -->
                <!-- :iconColor="hover ? 'white' : transparent" -->
              </div>
            </v-hover>
            <!--End: Insert Link--->
          </template>
        </draggable>
      </v-form>
      <UploadImageDialog
        :show="uploadImageDialog"
        @close="uploadImageDialog = false"
        previewType="thumbnail"
        @uploaded="handleUploaded"
        :link="selectedLinkForThumbnailUpload"
        :businessCardRotatorObject="transientLinkInBio"
      />
    </v-col>
  </v-row>
</template>

<script>
import Link from "@/models/Link";
import draggable from "vuedraggable";
import { mapActions, mapGetters } from "vuex";
import utility from "@/shared/utility";
import UploadImageDialog from "@/components/LinkInBio/UploadImageDialog";
import QRCode from "@/components/QRCode";
import AddLinkMenuButton from "@/components/LinkInBio/AddLinkMenuButton";
import {getHttpsCallable} from "@/shared/firebase_utils";

export default {
  components: {
    draggable,
    UploadImageDialog,
    QRCode,
    AddLinkMenuButton,
  },

  created() {
    this.timeout = setTimeout(function() {}, 0);
  },

  computed: {
    ...mapGetters(["transientLinkInBio", "linkInBio", "businessProfile"]),
    linkWithPappyon() {
      return "https://linkwith.pappyon.com/" + this.transientLinkInBio.id;
    },
    qrCodeLogo() {
      return this.businessProfile.logoImageURL || "";
    },
    showInsertLinkButton() {},
  },
  data() {
    return {
      drag: false,
      id: 0,
      uploadImageDialog: false,
      requiredRules: [(v) => v != "" || "This field is required"],
      shareMenuTab: 0,
      linkTitleRules: [(v) => v != "" || "This field is required"],
      selectedLinkForThumbnailUpload: {},
      transparent: "rgba(255, 255, 255, 0)",
      timeout: null,
    };
  },

  methods: {
    ...mapActions(["showSnackbar"]),
    addLink(type, index) {
      let link;
      if (type == "heading") link = new Link({ isHidden: false, type: "heading", id: this.id });
      else link = new Link({ isHidden: false, type: "link", id: this.id });
      // this.transientLinkInBio.links.push(link);
      this.transientLinkInBio.links.splice(index, 0, link);
      this.$nextTick(() => {
        //Autofocus newly added textfield
        // let lastIndex = this.transientLinkInBio.links.length - 1;
        this.$refs[`link${index}`][0].focus();
      });
    },
    handleRemove(index) {
      if (index != -1) this.transientLinkInBio.links.splice(index, 1);
    },
    copyToClipboard() {
      let copyText = "https://linkwith.pappyon.com/" + this.transientLinkInBio.id;
      utility.copyToClipboard(copyText);
      this.showSnackbar({ show: true, text: "Copied to clipboard" });
    },
    handleUploaded(downloadURL) {
      this.uploadImageDialog = false;
      // console.log("index: ", index);
      this.selectedLinkForThumbnailUpload.thumbnailUrl = downloadURL;
      this.selectedLinkForThumbnailUpload.isUserUploaded = true;
      // this.transientLinkInBio.links[this.selectedIndexForThumbnailUpload].thumbnailUrl = downloadURL;
    },
    validateForm() {
      console.log();

      //Form is valid
      if (this.$refs.addEditLinkForm.validate()) return this.$refs.addEditLinkForm.validate();
      else {
        //Loop through refs and autofocus first invalid ref
        this.$nextTick(() => {
          for (let i = 0; i < this.transientLinkInBio.links.length; i++) {
            //Autofocus first invalid title or heading textfield.
            if (this.$refs[`link${i}`][0].hasError) {
              this.$refs[`link${i}`][0].focus();
              break;
            }

            //Autofocus url field if link is valid
            if (this.transientLinkInBio.links[i].type == "link") {
              if (this.$refs[`url${i}`][0].hasError) {
                this.$refs[`url${i}`][0].focus();
                break;
              }
            }
          }
        });
        return this.$refs.addEditLinkForm.validate();
      }
    },
    shareViaEmail() {
      let linkWithPappyonURL = encodeURI("https://linkwith.pappyon.com/" + this.transientLinkInBio.id);
      window.open(`mailto:?subject=Link with Pappyon&body=${linkWithPappyonURL}`);
    },
    uploadThumbnail(link) {
      this.selectedLinkForThumbnailUpload = link;
      this.uploadImageDialog = true;
    },
    async handleChange1(link) {
      let getMetaDataFromURLTimeout = setTimeout(async function() {
        //Prepend protocol
        let url = link.url;

        if (url.indexOf("http://") != 0 && url.indexOf("https://") != 0) url = "http://" + url;

        //Regex to test if url format is valid
        let regexp = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;
        let isValidURL = regexp.test(url);

        if (isValidURL && !link.isUserUploaded) {
          console.log("calling cloud function for: ", url);
          // try {
          //   link.isLoading = true;
          //   const getMetaData = firebase.functions().httpsCallable("getMetaDataFromURL");
          //   let result = await getMetaData({ url: url });
          //   link.isLoading = false;

          //   if (result.data.images != undefined && result.data.images.length > 0) {
          //     link.thumbnailUrl = result.data.images[0];
          //     link.isUserUploaded = false;
          //   }
          // } catch (error) {
          //   link.isLoading = false;
          //   console.log("Error occurred while fetching thumbnail url: ", error);
          // }
        }
      }, 1000);
    },

    handleChange(link) {
      clearTimeout(this.timeout);
      let url = link.url;
      if (url.indexOf("http://") != 0 && url.indexOf("https://") != 0) url = "http://" + url;

      //Regex to test if url format is valid
      let regexp = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
      let isValidURL = regexp.test(url);

      if (isValidURL && !link.isUserUploaded) {
        this.timeout = setTimeout(async function() {
          let url = link.url;
          if (url.indexOf("http://") != 0 && url.indexOf("https://") != 0) url = "http://" + url;

          try {
            link.isLoading = true;
            const getMetaData = getHttpsCallable("getMetaDataFromURL");
            let result = await getMetaData({ url: url });
            link.isLoading = false;

            if (result.data.images != undefined && result.data.images.length > 0) {
              link.thumbnailUrl = result.data.images[0];
              link.isUserUploaded = false;
            }
          } catch (error) {
            link.isLoading = false;
            console.log("Error occurred while fetching thumbnail url: ", error);
          }
        }, 1000);
      }
    },

    deleteUploadedThumbnail(link) {
      link.thumbnailUrl = "";
      link.isUserUploaded = false;
    },
  },
};
</script>

<style scoped>
.draggable-card {
  box-shadow: 0px 4px 1px rgba(0, 36, 52, 0.1);
}

.v-list-item--link:hover {
  border-radius: 8px 8px 8px 8px !important;
}
.v-list-item--link:before {
  border-radius: 8px 8px 8px 8px !important;
}
.text-capitalize {
  text-transform: capitalize;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}

.hide-btns {
  color: rgba(255, 255, 255, 0) !important;
}

.cursor-grab {
  cursor: grab !important;
}

.cursor-grabbing {
  cursor: grabbing !important;
}

.outlined-border {
  border: 1px solid #e0e0e0;
}
</style>
